var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.336 28.864c-1.822 0-3.366-1.529-3.366-3.336 0-1.806 1.544-3.336 3.366-3.336 1.823 0 3.367 1.53 3.367 3.336 0 1.807-1.544 3.336-3.367 3.336zM33.142 41.912c-1.834 0-3.385-1.538-3.385-3.354 0-1.818 1.551-3.355 3.385-3.355 1.833 0 3.385 1.537 3.385 3.355 0 1.816-1.552 3.354-3.385 3.354zM33.142 44.451v2.335M45.336 31.307v15.48M33.142 17.643V32.5M45.336 17.643v2.048M21.034 35.054c-1.834 0-3.386-1.537-3.386-3.354 0-1.817 1.552-3.354 3.386-3.354 1.833 0 3.385 1.537 3.385 3.354 0 1.817-1.552 3.354-3.385 3.354zM21.034 37.594v9.192M21.034 17.643v8.001"
  })))));
};
export default SvgSetting;